import {useState, useEffect} from "react";
import {
  ApiResponseFromCMS,
  IClusterDataFromServer,
  IDirectionDataFromServer,
  IMoleculesDataFromServer,
  ITechMolecules2FromServerWithProducts,
} from "../pages/Dashboard/Dashboard.type";

const useFetchDataTehnologies = (
  apiUrlClusters: string,
  apiUrlDirections: string,
  apiUrlMolecules: string,
  apiUrlMolecules2: string,
  apiKey: string
) => {
  const [clustersData, setClustersData] = useState<ApiResponseFromCMS<
    IClusterDataFromServer[]
  > | null>(null);
  const [directionsData, setDirectionsData] = useState<ApiResponseFromCMS<
    IDirectionDataFromServer[]
  > | null>(null);
  const [moleculesData, setMoleculesData] = useState<ApiResponseFromCMS<
    IMoleculesDataFromServer[]
  > | null>(null);
  const [moleculesData2, setMoleculesData2] = useState<ApiResponseFromCMS<
    ITechMolecules2FromServerWithProducts[]
  > | null>(null);
  const [error, setError] = useState<Error | null>(null);
  const [isLoading, setIsLoading] = useState<boolean>(false);

  useEffect(() => {
    setIsLoading(true);
    const headers = new Headers({
      Authorization: `Bearer ${apiKey}`,
      "Content-Type": "application/json",
    });

    const clustersUrl = new URL(apiUrlClusters);
    const directionsUrl = new URL(apiUrlDirections);
    const moleculesUrl = new URL(apiUrlMolecules);
    const molecules2Url = new URL(apiUrlMolecules2);

    clustersUrl.searchParams.delete("populate");
    clustersUrl.searchParams.append("populate", "direction");
    clustersUrl.searchParams.append("populate", "image");
    clustersUrl.searchParams.set("filters[$or][0][molecule_only][$eq]", "false");
    clustersUrl.searchParams.set("filters[$or][1][molecule_only][$null]", "true");
    clustersUrl.searchParams.set("pagination[pageSize]", "1000");
    directionsUrl.searchParams.delete("populate");
    directionsUrl.searchParams.append("populate", "image");
    directionsUrl.searchParams.append("populate", "nptl");

    // moleculesUrl.searchParams.set(
    //   "populate[clusters][populate][cluster][populate][technologies][fields][0]",
    //   "name"
    // );
    moleculesUrl.searchParams.set(
      "populate[clusters][populate][cluster][fields][0]",
      "documentId"
    );
    moleculesUrl.searchParams.set(
      "populate[clusters][populate][technologies][populate][technology][fields][0]",
      "name"
    );
    moleculesUrl.searchParams.set("pagination[pageSize]", "500");

    molecules2Url.searchParams.set(
      "populate[products][populate][technologies][fields][0]",
      "name"
    );
    molecules2Url.searchParams.set("pagination[pageSize]", "500");

    Promise.all([
      fetch(clustersUrl.href, {headers}).then((response) => response.json()),
      fetch(directionsUrl.href, {headers}).then((response) => response.json()),
      fetch(moleculesUrl.href, {headers}).then((response) => response.json()),
      fetch(molecules2Url.href, {headers}).then((response) => response.json()),
    ])
      .then(([clustersData, directionsData, moleculesData, moleculesData2]) => {
        setClustersData(clustersData);
        setDirectionsData(directionsData);
        setMoleculesData(moleculesData);
        setMoleculesData2(moleculesData2);
        setIsLoading(false);
      })
      .catch((error) => {
        setError(error);
        setIsLoading(false);
      });
  }, [
    apiUrlClusters,
    apiUrlDirections,
    apiUrlMolecules,
    apiUrlMolecules2,
    apiKey,
  ]);
  return {
    clustersData,
    directionsData,
    moleculesData,
    moleculesData2,
    error,
    isLoading,
  };
};

export default useFetchDataTehnologies;
